import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { getBoundingBox } from '@/pages/AdvancedEditor/utils/getBoundingBox';
import { ElementsArray, ElementType, GroupElementType } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';

const alignRight = (element: ElementType, rightX: number) => {
    const box = getBoundingBox(element);
    const offsetX = box.maxX - element.x;
    element.set({ x: rightX - offsetX });
};

export function alignElementsRight(store: StoreType, elements: ElementsArray) {
    const rightX = elements.length > 1 ? Math.max(...elements.map(getBoundingBox).map(box => box.maxX)) : store.width;

    elements.forEach(element => {
        alignRight(element, rightX);

        if (element.type === polotnoTypes.Group) {
            (element as GroupElementType).children.forEach((child: ElementType) => {
                alignRight(child, rightX);
            });
        }
    });
}
